<template>
  <div class="cotti-modal" v-if="show" @click="popupHandler">
    <div class="cotti-modal-inner" v-if="!imgContent">
      <img v-if="type == 0" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/fail.png">
      <img v-if="type == 1" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/success.png" >
      <div v-if="title" class="title">{{title}}</div>
      <slot></slot>
      <div class="content">
        <div v-if="desc1 && desc1 !== ''" class="desc">
        <span v-for="(char, index) in desc1" :key="index">
            <span v-if="isNumber(char)" :style="{ color: '#A52337',fontWeight: 600 }" :class="isNumber(desc1[index - 1]) ? 'num-style-right' : isNumber(desc1[index + 1]) ? 'num-style-left' :'num-style'">{{ char }}</span>
            <span v-else>{{ char }}</span>
          </span>
      </div>
      <div v-if="desc2 && desc2 !== ''" class="desc">
        <span v-for="(char, index) in desc2" :key="index">
            <span v-if="isNumber(char)" :style="{ color: '#A52337',fontWeight: 600 }" :class="isNumber(desc2[index - 1]) ? 'num-style-right' : isNumber(desc2[index + 1]) ? 'num-style-left' :'num-style'">{{ char }}</span>
            <span v-else>{{ char }}</span>
          </span>
      </div>
      </div>
              
      <!-- <div class="desc-list" v-if="descList.length > 0">
        <div v-for="(item, index) in descList" :key="index" class="desc-item">
           <span class="order-text"> {{index + 1}}. </span>
           <span class="desc-text">{{item}}</span>
        </div>
      </div> -->
      <div class="confirm-btn" @click.stop="confirmHandler">{{btnText}}</div>
    </div>
    <div class="adImg" v-else>
      <slot></slot>
    </div>
    <div v-if="imgContent" class="cotti-modal-close" @click.stop="closeHandler">
      <img src="@/assets/pointsActivity/icon_close.png" alt="关闭">
    </div>
  </div>
</template>

<script>
export default {
  name: 'CottiModal',
  props: {
    type: {
      type: Number,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    desc1: {
      type: String,
      default: ''
    },
    desc2: {
      type: String,
      default: ''
    },
    descList: {
      type: Array,
      default: () => []
    },
    btnText: {
      type: String,
      default: '我知道了'
    },
    imgContent:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {}
  },
  methods: {
    isNumber(char) {
      return /[0-9]/.test(char);
    },
    confirmHandler() {
      this.$emit('onConfirm')
    },
    closeHandler() {
        this.$emit('onClose')
    },
    popupHandler() {
      if (this.closeOnClickOverlay) {
        this.closeHandler()
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.cotti-modal {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  padding-top: 60%;
  position: fixed;
  top: 0;
  left: 0;
  z-index:9999;
  background-color: rgba(0, 0, 0, 0.55);

  .adImg{
    .adImgSize{
      width: 686px;
      height:auto;
      border-radius: 8px;
    }
  }

  &-inner {
    width: 510px;
    background: #FFFFFF;
    border-radius: 16px;
    padding: 32px 40px 36px 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img{
      width: 128px;
    }
    .title{
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #3A3B3C;
      line-height: 44px;
      margin: 24px 0;
    }
    .content {
      margin-bottom: 40px;
    }
    .desc {
      text-align: justify;
      border-radius: 8px;
      line-height: 48px;
      // margin-bottom: 40px;
      color: #3A3B3C;
      font-size: 28px;
      font-weight: 400;
      text-align: center;
      white-space: normal;
      .num-style {
        margin: 0 8px;
      }
      .num-style-left {
        margin: 0 0 0 8px;
      }
      .num-style-right {
        margin: 0 8px 0 0;
      }
    }
    .desc-list{
      text-align: justify;
      padding: 24px;
      background: #F5F5F5;
      border-radius: 8px;
      line-height: 34px;
      margin-bottom: 40px;
      .desc-item {
        margin: 4px 0;
        .order-text {
        color:#A52337;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
      }
      .desc-text {
        color: #3A3B3C;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
      }
      }
    }
    .confirm-btn {
      width: 510px;
      height: 86px;
      background: linear-gradient( 90deg, #FF7673 0%, #FF3D3D 100%);
      border-radius: 44px;
      font-weight: 600;
      font-size: 28px;
      color: #FFFFFF;
      line-height: 88px;
      text-align: center;
    }
  }
  &-close{
    width: 64px;
    height: 64px;
    margin-top: 64px;
    >img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
